import { gettext } from '@eventbrite/i18n';
import arts from '../../../static/images/categories/arts.png';
import auto from '../../../static/images/categories/auto.png';
import business from '../../../static/images/categories/business.png';
import charity_and_causes from '../../../static/images/categories/charity_and_causes.png';
import community from '../../../static/images/categories/community.png';
import family from '../../../static/images/categories/family.png';
import fashion from '../../../static/images/categories/fashion.png';
import film_and_media from '../../../static/images/categories/film_and_media.png';
import food from '../../../static/images/categories/food_and_drink.png';
import government from '../../../static/images/categories/government.png';
import health from '../../../static/images/categories/health.png';
import hobbies from '../../../static/images/categories/hobbies.png';
import holiday from '../../../static/images/categories/holiday.png';
import home from '../../../static/images/categories/home.png';
import music from '../../../static/images/categories/music.png';
import school from '../../../static/images/categories/school.png';
import science from '../../../static/images/categories/science.png';
import spirituality from '../../../static/images/categories/spirituality.png';
import sports from '../../../static/images/categories/sports.png';
import travel from '../../../static/images/categories/travel.png';
import {
    AUTO_BOAT_AIR_EVENTBRITE_CATEGORY,
    BUSINESS_EVENTBRITE_CATEGORY,
    CHARITY_EVENTBRITE_CATEGORY,
    COMMUNITY_EVENTBRITE_CATEGORY,
    EVENTBRITE_CATEGORY_DISPLAY_MAPPING,
    FAMILY_EDUCATION_EVENTBRITE_CATEGORY,
    FASHION_EVENTBRITE_CATEGORY,
    FILM_EVENTBRITE_CATEGORY,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    HEALTH_EVENTBRITE_CATEGORY,
    HOBBIES_EVENTBRITE_CATEGORY,
    HOME_LIFESTYLE_EVENTBRITE_CATEGORY,
    MUSIC_EVENTBRITE_CATEGORY,
    OTHER_EVENTBRITE_CATEGORY,
    PERFORMING_EVENTBRITE_CATEGORY,
    POLITICS_EVENTBRITE_CATEGORY,
    RELIGION_EVENTBRITE_CATEGORY,
    SCHOOL_EVENTBRITE_CATEGORY,
    SCIENCE_EVENTBRITE_CATEGORY,
    SEASONAL_EVENTBRITE_CATEGORY,
    SPORTS_EVENTBRITE_CATEGORY,
    TRAVEL_EVENTBRITE_CATEGORY,
} from './categories';

const THINGS_TO_DO_MUSIC_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[MUSIC_EVENTBRITE_CATEGORY],
    imageUrl: music,
    key: MUSIC_EVENTBRITE_CATEGORY,
    slug: 'music',
};

const THINGS_TO_DO_BUSINESS_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[BUSINESS_EVENTBRITE_CATEGORY],
    imageUrl: business,
    key: BUSINESS_EVENTBRITE_CATEGORY,
    slug: 'business',
};

const THINGS_TO_DO_PERFORMING_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[PERFORMING_EVENTBRITE_CATEGORY],
    imageUrl: arts,
    key: PERFORMING_EVENTBRITE_CATEGORY,
    slug: 'arts',
};

const THINGS_TO_DO_FILM_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[FILM_EVENTBRITE_CATEGORY],
    imageUrl: film_and_media,
    key: FILM_EVENTBRITE_CATEGORY,
    slug: 'film-and-media',
};

const THINGS_TO_DO_SPORTS_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[SPORTS_EVENTBRITE_CATEGORY],
    imageUrl: sports,
    key: SPORTS_EVENTBRITE_CATEGORY,
    slug: 'sports-and-fitness',
};

const THINGS_TO_DO_FOOD_AND_DRINK_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[
        FOOD_AND_DRINK_EVENTBRITE_CATEGORY
    ],
    imageUrl: food,
    key: FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    slug: 'food-and-drink',
};

const THINGS_TO_DO_HOBBIES_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[HOBBIES_EVENTBRITE_CATEGORY],
    imageUrl: hobbies,
    key: HOBBIES_EVENTBRITE_CATEGORY,
    slug: 'hobbies',
};

const THINGS_TO_DO_HEALTH_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[HEALTH_EVENTBRITE_CATEGORY],
    imageUrl: health,
    key: HEALTH_EVENTBRITE_CATEGORY,
    slug: 'health',
};

const THINGS_TO_DO_TRAVEL_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[TRAVEL_EVENTBRITE_CATEGORY],
    imageUrl: travel,
    key: TRAVEL_EVENTBRITE_CATEGORY,
    slug: 'travel-and-outdoor',
};

const THINGS_TO_DO_FASHION_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[FASHION_EVENTBRITE_CATEGORY],
    imageUrl: fashion,
    key: FASHION_EVENTBRITE_CATEGORY,
    slug: 'fashion',
};

const THINGS_TO_DO_SCIENCE_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[SCIENCE_EVENTBRITE_CATEGORY],
    imageUrl: science,
    key: SCIENCE_EVENTBRITE_CATEGORY,
    slug: 'science-and-tech',
};

const THINGS_TO_DO_CHARITY_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[CHARITY_EVENTBRITE_CATEGORY],
    imageUrl: charity_and_causes,
    key: CHARITY_EVENTBRITE_CATEGORY,
    slug: 'charity-and-causes',
};

const THINGS_TO_DO_POLITICS_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[POLITICS_EVENTBRITE_CATEGORY],
    imageUrl: government,
    key: POLITICS_EVENTBRITE_CATEGORY,
    slug: 'government',
};

const THINGS_TO_DO_COMMUNITY_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[COMMUNITY_EVENTBRITE_CATEGORY],
    imageUrl: community,
    key: COMMUNITY_EVENTBRITE_CATEGORY,
    slug: 'community',
};

const THINGS_TO_DO_RELIGION_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[RELIGION_EVENTBRITE_CATEGORY],
    imageUrl: spirituality,
    key: RELIGION_EVENTBRITE_CATEGORY,
    slug: 'spirituality',
};

const THINGS_TO_DO_FAMILY_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[
        FAMILY_EDUCATION_EVENTBRITE_CATEGORY
    ],
    imageUrl: family,
    key: FAMILY_EDUCATION_EVENTBRITE_CATEGORY,
    slug: 'family-and-education',
};

const THINGS_TO_DO_SEASONAL_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[SEASONAL_EVENTBRITE_CATEGORY],
    imageUrl: holiday,
    key: SEASONAL_EVENTBRITE_CATEGORY,
    slug: 'holiday',
};

const THINGS_TO_DO_HOME_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[
        HOME_LIFESTYLE_EVENTBRITE_CATEGORY
    ],
    imageUrl: home,
    key: HOME_LIFESTYLE_EVENTBRITE_CATEGORY,
    slug: 'home-and-lifestyle',
};

const THINGS_TO_DO_AUTO_BOAT_AIR_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[
        AUTO_BOAT_AIR_EVENTBRITE_CATEGORY
    ],
    imageUrl: auto,
    key: AUTO_BOAT_AIR_EVENTBRITE_CATEGORY,
    slug: 'auto-boat-and-air',
};

const THINGS_TO_DO_SCHOOL_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[SCHOOL_EVENTBRITE_CATEGORY],
    imageUrl: school,
    key: SCHOOL_EVENTBRITE_CATEGORY,
    slug: 'school-activities',
};

const THINGS_TO_DO_OTHER_CONTENT = {
    title: gettext('Eclectic'),
    imageUrl: travel,
    key: OTHER_EVENTBRITE_CATEGORY,
    slug: 'other',
};

export const CATEGORY_CONTENT_MAP = {
    [MUSIC_EVENTBRITE_CATEGORY]: THINGS_TO_DO_MUSIC_CONTENT,
    [BUSINESS_EVENTBRITE_CATEGORY]: THINGS_TO_DO_BUSINESS_CONTENT,
    [PERFORMING_EVENTBRITE_CATEGORY]: THINGS_TO_DO_PERFORMING_CONTENT,
    [FILM_EVENTBRITE_CATEGORY]: THINGS_TO_DO_FILM_CONTENT,
    [SPORTS_EVENTBRITE_CATEGORY]: THINGS_TO_DO_SPORTS_CONTENT,
    [FOOD_AND_DRINK_EVENTBRITE_CATEGORY]: THINGS_TO_DO_FOOD_AND_DRINK_CONTENT,
    [HOBBIES_EVENTBRITE_CATEGORY]: THINGS_TO_DO_HOBBIES_CONTENT,
    [HEALTH_EVENTBRITE_CATEGORY]: THINGS_TO_DO_HEALTH_CONTENT,
    [TRAVEL_EVENTBRITE_CATEGORY]: THINGS_TO_DO_TRAVEL_CONTENT,
    [FASHION_EVENTBRITE_CATEGORY]: THINGS_TO_DO_FASHION_CONTENT,
    [SCIENCE_EVENTBRITE_CATEGORY]: THINGS_TO_DO_SCIENCE_CONTENT,
    [CHARITY_EVENTBRITE_CATEGORY]: THINGS_TO_DO_CHARITY_CONTENT,
    [POLITICS_EVENTBRITE_CATEGORY]: THINGS_TO_DO_POLITICS_CONTENT,
    [COMMUNITY_EVENTBRITE_CATEGORY]: THINGS_TO_DO_COMMUNITY_CONTENT,
    [RELIGION_EVENTBRITE_CATEGORY]: THINGS_TO_DO_RELIGION_CONTENT,
    [FAMILY_EDUCATION_EVENTBRITE_CATEGORY]: THINGS_TO_DO_FAMILY_CONTENT,
    [SEASONAL_EVENTBRITE_CATEGORY]: THINGS_TO_DO_SEASONAL_CONTENT,
    [HOME_LIFESTYLE_EVENTBRITE_CATEGORY]: THINGS_TO_DO_HOME_CONTENT,
    [AUTO_BOAT_AIR_EVENTBRITE_CATEGORY]: THINGS_TO_DO_AUTO_BOAT_AIR_CONTENT,
    [SCHOOL_EVENTBRITE_CATEGORY]: THINGS_TO_DO_SCHOOL_CONTENT,
    [OTHER_EVENTBRITE_CATEGORY]: THINGS_TO_DO_OTHER_CONTENT,
};
